import {AbstractModel} from '../abstract-model';

export class BillingLine extends AbstractModel {
  id: number | null = null;
  category: string = 'payment';
  amountTaxExcl: number = 0;
  vatAmount: number = 0;
  amountTaxIncl: number = 0;
  currencyAmountTaxExcl: number = 0;
  currencyVatAmount: number = 0;
  currencyAmountTaxIncl: number = 0;
}
